import { Box, Typography } from '@mui/material';
import Link from 'next/link';

import { LOCATION_ROUTES } from '@/helpers/locationPages';

function CategoryCrossLinks({
  locationSlug,
  locationName,
  currentCategorySlug,
  allCategories,
}) {
  const otherCategories = (allCategories ?? []).filter(
    cat => cat.slug !== currentCategorySlug
  );

  if (!otherCategories.length) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" color="primary.dark" sx={{ mb: 0.75 }}>
        Weitere Mietkategorien in {locationName}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {otherCategories.map(cat => (
          <Link
            key={cat.slug}
            href={`${LOCATION_ROUTES.BASE_PATH}/${locationSlug}/${cat.slug}`}>
            <Typography variant="body2" color="primary.main">
              {cat.name}
            </Typography>
          </Link>
        ))}
      </Box>
    </Box>
  );
}

export default CategoryCrossLinks;
